/**
 * 设备数据接口
 */

import instance from '@/utils/axios';

/**
 * 修改设备名称
 * @param {设备号} sn
 * @param {修改后的名称} name
 * @param {经度} longitude
 * @param {纬度} latitude
 */
export function updateDeviceInfo(params) {
  return instance.get('/devicedata/updateDeviceInfo', { params });
}

/**
 * 获取高斯烟团模型数据
 * @param {设备号} sn
 */
export function getSmokePuff(sn) {
  return instance.get('/devicedata/smokePuff', {
    params: {
      sn
    }
  });
}

/**
 *
 * @param {{sn: string, type: string, deviceType: string}} params
 */
export function clearBground(params) {
  return instance.get('/devicedata/clearBground', {
    params
  });
}

/**
 * 获取设备最新的数据
 * @param {设备号} sn
 */
export function queryLatestData(sn) {
  return instance.get('/devicedata/hisDeviceData', {
    params: {
      sn
    }
  });
}

/**
 * 获取机构或者设备相关场景地图信息
 * @param {id} 机构或者设备id
 * @param {nodeType} 1: 机构 2：设备
 * @param {{id: string, nodeType: number}} data
 */
export function queryStationMap(data) {
  return instance.get('/devicedata/sceneMap', {
    params: { ...data }
  });
}

/**
 * 根据compinationId获取设备关联sn列表
 * @param { combinationId } data
 * @returns {{ id: string, combinationName: string, link:{ id: string, sn:StringConstructor, sort: number }[] }}
 */
export function getDeviceGroupById(data) {
  return instance.get('/device/getDeviceCombinationById', {
    params: { ...data }
  });
}

/**
 * 获取设备型号信息（图片缓存）
 */
export function getDeviceTypeInfo() {
  return instance.get('/device/getDeviceTypeInfo');
}

/**
 * 退出显示图详情调用接口
 */
export function stopDeviceMap() {
  return instance.get('/devicemap/stopDeviceMap');
}

/**
 * 退出显示图回放调用接口
 */
export function stopReplay() {
  return instance.get('/devicemap/stopReplay');
}

/**
 * 合并报警
 * @param {{ids:string[],alarmGroupId:string}} data
 * @returns
 */
export function mergeAlarm(data) {
  return instance.post('/devicedata/mergeAlarm', data);
}

/**
 * 同步gd系列设备传感器信息
 * @param {string} sn
 * @returns
 */
export function syncGdSensorConfig(sn) {
  return instance.get('/device/syncGdSensorConfig', {
    params: { sn }
  });
}

/**
 * 自校准
 * @param {Object} data
 * @param {string} data.sn
 * @param {number} data.sensorSeq
 * @returns
 */
export function selfCalibration(data) {
  return instance.post('/devicecontrol/selfCalibration', {
    ...data
  });
}

/**
 * 获取自校准传感器列表
 * @param {string} sn
 * @returns
 */
export function getSensorList(sn) {
  return instance.post('/devicecontrol/getSensors', { sn });
}

/**
 * 设置自清洁状态
 * @param {Object} data
 * @param {string} data.sn
 * @param {number} data.selfCleanTime
 * @returns
 */
export function selfCleaning(data) {
  return instance.post('/devicecontrol/selfClean', { ...data });
}

/**
 * 获取自清洁状态
 * @param {string} sn
 * @returns
 */
export function getSelfCleaningStatus(sn) {
  return instance.post('/devicecontrol/checkSelfCleanStatus', { sn });
}

/**
 * 设置设备数据发送间隔
 * @param {Object} data
 * @param {string} data.sn 设备sn
 * @param {number} data.dataInterval - 秒
 * @returns
 */
export function setSendDataInterval(data) {
  return instance.post('/devicecontrol/sendDataInterval', { ...data });
}

/**
 * 获取无线盒子设备
 * @returns
 */
export function getWirelessBoxListServer(deviceTypeCode) {
  return instance.get(`/wirelessBox/getBoxDevice?deviceTypeCode=${deviceTypeCode}`);
}

/**
 * 查询传感器等级
 * @param {*} data 【'deviceType'】
 * @returns
 */
export function getSensorsGradeServer(data) {
  return instance.post('/stat/getDeviceSensorTypeGrade', data);
}

/**
 * 设置Rfqf01参数
 * @param {*} data
 * @returns
 */
export function setRfqf01ConfigServer(data) {
  return instance.post('/devicecontrol/setRfqf01Param', data);
}

/**
 * 查询308,AC200,RFQF01设备参数
 * @param {*} sn
 * @param {*} busiType
 * @returns
 */
export function getDevicesParamServer(sn, busiType) {
  return instance.get(`/param/queryParam?sn=${sn}&busiType=${busiType}`);
}

/**
 * 修改308,AC200，RFQF01设备参数
 * @param {*} data
 * @returns
 */
export function updateDevicesParams(data) {
  return instance.post('/param/updateParam', data);
}

/**
 * 通用-- 模块开关设置接口
 * @param {*} data
 * @returns
 */
export function setDeviceModCtrlServer(data) {
  return instance.get(
    `/hwperipheral/modCtrlSetting?deviceType=${data.deviceType}&sn=${data.sn}&currState=${data.currState}`
  );
}

/**
 * 根据sn获取盒子参数
 * @param {string} sn
 * @returns {Promise<any>}
 */
export function getFr01BoxConfigBySn(sn) {
  return instance.get(
    '/wirelessBox/getDownlinkConfigInfoBySn',
    { params: { sn } },
    { disableDefTips: true }
  );
}

/**
 * 根据sn获取盒子参数
 * @param {Object} config - 配置对象
 * @param {number} config.downlinkPort - 下行端口
 * @param {string} config.pollingContent - 轮训包内容，字符串类型，以\0结尾
 * @param {number} config.pollingCycle - 轮训周期，单位：秒，0为不轮询
 * @param {number} config.portBaudRate - 端口波特率
 * @param {string} config.portDesc - 端口描述，字符串类型，以\0结尾
 * @param {number} config.powerEnable - 端口输出电源，0-关，1-开
 * @returns {Promise<any>}
 */
export function setFr01BoxConfigBySn(config) {
  return instance.post('/wirelessBox/setDownlinkConfig', { ...config });
}

/**
 * 同步时间
 * @param {*} data
 * @param {string} data.sn -sn
 * @param {string} data.deviceType - deviceType
 * @returns
 */
export function setTimeServer(data) {
  return instance.get(
    `/hwperipheral/timeSetting?sn=${data.sn}&deviceType=${data.deviceType}&currTime=${data.currTime}`
  );
}

/**
 * 获取Bu10最近一条检测数据
 * @param {*} sn
 * @returns
 */
export function getBu10LastDataServer(sn) {
  return instance.get(`/bu10devicedata/lastDetectDetail?sn=${sn}`);
}
